import { de_DE_formal } from "@App/locales/de_DE-formal";
import { de_DE_globalTranslations } from "@App/locales/de_DE-globalTranslations";

export const octopusev = {
  ...de_DE_formal,
  ...{
    translation: {
      ...de_DE_globalTranslations.translation,
      "Partnerwerkstaetten in Ihrer Naehe": "Octopus Werkstätten in Ihrer Nähe",
      hero: {
        title: "<strong>Willkommen bei der Werkstatt-Buchung von {{organization}}</strong>",
        subtitle: null,
      },
      layout: {
        backText: "Zurück zu octopusev.com",
        navbar: {
          partnerLogo: {
            alt: "Octopus Electric Vehicles",
          },
        },
      },
      linkToHome: "https://werkstatt.repareo.de/partner/octopusev",
    },
  },
};
